/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import 'styles/tailwindcss.scss';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { CreateAccountLayout } from 'components/layout/CreateAccountLayout';
import FormChooseRole from './FormChooseRole';
import FormRegister from './FormRegister';
import FormStudentInfo from './FormStudentInfo';
import { useFormik } from 'formik';
import { USER_ROLE } from 'constants/common';
import * as Yup from 'yup';
import { routers } from 'router/router';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { useAppDispatch } from 'app/hooks';
import {  login,   createStudent } from 'app/authorization/authorizationSlice';
import {  logout } from 'app/basicInformationSlice/basicInformationSlice';
import authorizationServices from 'services/authorizationServices';
import {  getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';
import { get, set } from 'lodash';
import Cookies from 'js-cookie';
import partnerServices from 'services/partnerServices';
import FormInviteStudent from './FormInviteStudent';
import FormGradMapReady from './FormGradMapReady';
import FormCounselorSetup from './FormCounselorSetup';
import FormAuthPhoneNumber from './FormAuthPhoneNumber';
import PaymentServices from 'services/payment';
import basicInformationServices from 'services/basicInformationApi';
import { Button } from 'react-bootstrap';
import {
  clearPartnerInviteContext,
  getEffectiveSearch,
  getInviteTokenFromSearch,
  getPersistedInviteToken,
  INVITE_TOKEN_QUERY,
  persistInviteMeta,
  persistInviteToken,
  PartnerInviteValidateResponse,
  setInviteRedirectAfterOnboarding,
  stripInviteTokenFromSearch,
  syncInviteTokenDocumentSearchToHashRouter,
} from 'utils/partnerInvite';

interface Props {}

const RegisterPage = (props: Props) => {
  const [step, setStep] = React.useState('1');
  /** Full create-account flow (validate → createStudent → login → …). Not tied to Redux `loading` (idle between thunks toggles the button). */
  const [registerCreateLocked, setRegisterCreateLocked] = React.useState(false);
  const dispatch:any = useAppDispatch();
  const history = useHistory();

  React.useLayoutEffect(() => {
    syncInviteTokenDocumentSearchToHashRouter();
  }, []);
  const [sessionExistsModal, setSessionExistsModal] = useState({
    open: false,
    message: '',
    activeSessions: [] as Array<{ device: string; lastSeen: string; ipAddress: string }>,
  });
  const [loginCredentials, setLoginCredentials] = useState<{ email: string; password: string } | null>(null);
  const params = new URLSearchParams(history.location.search);
  const stepURL = params.get('step');
  const priceName = params.get('price');
  // let paymentPath = priceName ? `${routers.payment.path}?price=${priceName}` : routers.payment.path;

  const query = new URLSearchParams(useLocation().search);
  const email = query.get('email');
  const first_name = query.get('first_name');
  const last_name = query.get('last_name');
  const [provider, setProvider] = useState(query.get('google'));
  const redirectId = query.get('id') ?? '';
  const catId = query.get('catid') ?? '';
  Cookies.set('redirectId', redirectId);
  Cookies.set('catId', catId);
  let userRole = sessionStorage.getItem('userRole');

  const [inviteValidation, setInviteValidation] = React.useState<{
    loading: boolean;
    data: PartnerInviteValidateResponse | null;
    error: string | null;
  }>({ loading: false, data: null, error: null });
  console.log("🚀 ~ RegisterPage ~ inviteValidation:", inviteValidation)

  const routerSearch = useLocation().search;
  const locationSearch = React.useMemo(
    () => getEffectiveSearch(routerSearch),
    [routerSearch]
  );

  React.useEffect(() => {
    const token = getInviteTokenFromSearch(locationSearch) || getPersistedInviteToken();
    if (!token) {
      setInviteValidation({ loading: false, data: null, error: null });
      return;
    }
    persistInviteToken(token);
    let cancelled = false;
    setInviteValidation((s) => ({ ...s, loading: true, error: null }));
    partnerServices
      .validateInviteToken(token)
      .then((res: PartnerInviteValidateResponse) => {
        if (cancelled) return;
        if (res?.valid) {
          persistInviteMeta(res);
          setInviteValidation({ loading: false, data: res, error: null });
        } else {
          clearPartnerInviteContext();
          setInviteValidation({
            loading: false,
            data: res,
            error: res?.message || 'This invitation link is invalid, expired, or already used.',
          });
        }
      })
      .catch(() => {
        if (cancelled) return;
        setInviteValidation({
          loading: false,
          data: null,
          error: 'Could not verify the invitation. Please try again or request a new invite.',
        });
      });
    return () => {
      cancelled = true;
    };
  }, [locationSearch]);

  const formik = useFormik({
    initialValues: {
      email: email || '',
      first_name: first_name || '',
      last_name: last_name || '',
      user_role: '',
      school_or_organization_work_with: '',
      year_finish_high_school: new Date().getFullYear() + 1,
      password: '',
      state: '',
      city: '',
      csu_city: '',
      password_confirm: '',
      additional_info: {
        where_attend_high_school: '',
        school_system: '',
        high_school_name: '',
        majors_interest_1: '',
        majors_interest_2: '',
        year_plan_college_studies:  `${new Date().getFullYear()}`, //'2025',
        first_name: '',
        last_name: '',
        relationship_to_you: '',
        prefered_email: '',         // also is parent_email
        parent_first_name: '',
        parent_last_name: '',
        accept_contact: false,
        est_supported_students: '', //ex:'10-12 students' // Estimated/Approximate number of students you support
      } as any,
      price_name: priceName,
      schoolId: '',
      parent_email: '',
      is_register_parent_account: false,
      parent_password: '',
      parent_password_confirm: '',
      google_id: ''
    },
    validateOnChange: false,
    validateOnBlur: true,
    validate: async (values) => {
      console.log('formik.values:', formik.values)
      const errors: any = {};
      let schema;
      if (step === '2') {
        console.log('provider:', provider);
        schema = getUserPassValidationSchema(provider);
      } else
      if (step === '3c') {
        //schema = getStep3cValidationSchema();
        return errors;
      }
     
      if (schema) {
        try {
          // validateSync is faster for basic fields, or use validate for async
          await schema.validate(values, { abortEarly: false });
        } catch (yupError: any) {
          // Convert Yup errors to Formik nested object format
          yupError.inner.forEach((err: any) => {
            set(errors, err.path, err.message); // Use lodash 'set' for nested paths like additional_info.first_name
          });
        }
      }

      // 2. Dynamic/Async Validation (API Check)
      if (step === '2') {
        const trimmedEmail = values.email?.trim();
        if (!trimmedEmail) {
          errors.email = 'Email is required';
        } 

        // Only check API if Yup hasn't already flagged the email as invalid
        else if (!errors.email && !provider) {
          try {
            const isValidEmail = await authorizationServices.checkValidEmail(values.email.trim());
            const emailCheckStatus =
              isValidEmail?.statusCode ?? isValidEmail?.response?.data?.statusCode;
            const emailCheckMessage =
              isValidEmail?.message ?? isValidEmail?.response?.data?.message ?? '';
            if (emailCheckStatus === 400 || emailCheckMessage.includes('Email already registered')) {
              errors.email = emailCheckMessage.includes('Email already registered')
                ? 'The email is already used. Please choose another one.'
                : emailCheckMessage || 'The email is already used. Please choose another one.';
            }
          } catch (apiErr: any) {
            console.error('Email check failed', apiErr);
            const data = apiErr?.response?.data;
            if (data?.statusCode === 400 || data?.message?.includes('Email already registered')) {
              errors.email = 'The email is already used. Please choose another one.';
            }
          }
        }
      }

      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      const releaseCreateButton = () => {
        setRegisterCreateLocked(false);
        setSubmitting(false);
      };

      try {
        // console.log('submit values:', values);
        // console.log('Register submit!');
        // console.log('current step: ', step);
        let studentId = getUserId();
        let token = getAccessToken();
        userRole = sessionStorage.getItem('userRole');
        // console.log('current token: ', token);
        // console.log('current step: ', step);
        if (step==='2') {
          setRegisterCreateLocked(true);
          let res:any = null;
          //#region prepare data to createStudent
          const { price_name, ...newValues }: any = values; // newValues except for price_name
          const highSchoolData = {
            counselor_prefix: '',
            counselor_first_name: '',
            counselor_middle_initial: '',
            counselor_last_name: '',
            counselor_job_title: '',
            counselor_email: '',
            counselor_country_code: '',
            counselor_phone_number: '',
            graduating_class_size: null,
            class_rank_reporting: null,
            gpa_scale_reporting: null,
            culmative_gpa: null,
            gpa_weighting: null,
            other_school_array: [{}],
            number_of_other_school_attended: 0,
            high_school_info: {
              where_attend_high_school: '',
              state: '',
              city: '',
              country: '',
              is_home_school: false,
              is_independant_study: false,
              my_home_school_associated_with_high_school: false,
              school_name: '',
              school_type: '',
              left_highschool_reason: '',
            },
            graduating_school_array: [{}],
            high_school_array: [
              {
                where_attend_high_school: get(
                  newValues,
                  'additional_info.where_attend_high_school',
                  ''
                ),
                state: values.state,
                city: values.city,
                country: '',
                is_home_school: false,
                is_independant_study: false,
                my_home_school_associated_with_high_school: false,
                school_name: '',
                school_type: '',
                high_school_name: get(newValues, 'additional_info.high_school_name', ''),
                degree: '',
                month: '',
                day: '',
                year: '',
                grade: [],
                academic_year: [],
                is_summer_took: [],
                specialized_curriculum_career: false,
                specialized_curriculum_international: false,
                specialized_curriculum_magnet: false,
                specialized_curriculum_other: false,
                specialized_curriculum_other_free_text: '',
                grading_scale: '',
                grading_scale_is_abcdf: false,
                grading_scale_is_0_100: false,
                grading_scale_is_1_7: false,
                grading_scale_is_other: false,
                is_block_scheduling: false,
                degreeFreeText: '',
                lowest_number_grade: '',
                highest_number_grade: '',
                classes_schedule: get(newValues, 'additional_info.school_system', ''),
                other_grading_system: '',
                graduating_high_school: '',
                school_term_1: false,
                school_term_2: false,
                school_term_3: false,
                school_term_4: false,
                high_school_object: newValues?.high_school_object || {},
                is_boarding_school: '',
                is_graduate_from_this_school: '',
                is_live_on_campus: '',
                graduation_status: '',
                academic_performance: '',
                name_of_degree: '',
                allNoneAGCourses: false,
                have_other_grading_system: false,
                second_grading_system: '',
                csu_city: values.csu_city,
              },
            ],
          };
          const inviteTok = getPersistedInviteToken();
          const newData = {
            ...newValues,
            email: values.email.trim(),
            additional_info: JSON.stringify(values.additional_info),
            high_school_data: JSON.stringify(highSchoolData),
            ...(inviteTok ? { invite_token: inviteTok } : {}),
          };
          //#endregion
          
          res = await dispatch(createStudent(newData));
          console.log('createStudent ~ res:', res);

          if (createStudent.rejected.match(res)) {
            const errPayload = res.payload as any;
            const message: string =
              typeof errPayload === 'string'
                ? errPayload
                : errPayload?.message ?? errPayload?.response?.data?.message ?? '';

            if (message.includes('Duplicated user email')) {
              const tok = getPersistedInviteToken();
              if (tok) {
                toast.error('This email already has an account. Sign in to accept the invitation.');
                history.push(`${routers.login.path}?${INVITE_TOKEN_QUERY}=${encodeURIComponent(tok)}`);
              } else {
                handleNextStep('2');
                formik.setErrors({
                  email: 'The email is already used. Please choose another one.',
                });
                formik.setFieldTouched('email', true, false);
              }
            } else if (message.includes('Duplicated parent email')) {
              handleNextStep('2');
              formik.setFieldError('parent_email', 'The email is already used. Please choose another one.');
              formik.setFieldTouched('parent_email', true, false);
            } else if (message) {
              toast.error(message);
            } else {
              toast.error('Registration failed. Please try again.');
            }
            releaseCreateButton();
            return;
          }

          if (res.payload?.statusCode === 200) {
              if (inviteTok) {
                setInviteRedirectAfterOnboarding();
              }
              clearPartnerInviteContext();
              {
                const path = history.location.pathname || '/public/register';
                const cleanSearch = stripInviteTokenFromSearch(history.location.search || '');
                history.replace({ pathname: path, search: cleanSearch });
              }
              partnerServices.sync(values.email);
              Cookies.set('userId', res.payload.student_id);
              Cookies.set('request_id', res.payload.student_id);
              Cookies.set('userEmail', values.email);

              
              // Register usIng Google
              if (formik.values.google_id) {                  
                  // //#region Silent Login
                  // if (res.payload.user_role === USER_ROLE.student) {
                  // //#region Active Free Plan
                  // const studentId = Number(res.payload?.student_id) || Number(getUserId()?? 0);
                  // const res3:any = await PaymentServices.activeFreePlan(
                  //   studentId,
                  //   formik.values.email,
                  //   formik.values.first_name,
                  //   formik.values.last_name,
                  // )
                  // console.log('activeFreePlan() ~ res3:', res3);                  
                  // }

                  // setLoginCredentials(values);
                  // //#endregion
                  // handleNextStep('3a', true);
              }
              //else 
              
              {
                //#region 'Run Silent Login
                console.log('Run Silent Login');
                // Store credentials for potential retry with force=true
                setLoginCredentials(values);

                const res2: any = await dispatch(login(values));
                console.log('login: res2:', res2);
                const token = getAccessToken();
                console.log('token:', token);               
                //#endregion

                //#region check Login Error
                if (res2?.error?.message === 'User not found') {
                  toast.error('User not found');
                  //history.push(routers.register.path);
                  // setSubmitting(false);
                  releaseCreateButton();
                  return;
                }

                if (res2?.error?.message === 'Network Error') {
                  toast.error('Network Error: Please check your internet connection or backend server.');
                  releaseCreateButton();
                  return;
                }
                //#endregion
                  
                if (res2.payload) {
                  //#region Check Error/ catch error from api PassportStrategy
                  // Check for SESSION_EXISTS error (statusCode 430)
                  if (res2.payload.statusCode === 430 && res2.payload.code === 'SESSION_EXISTS') {
                    setSessionExistsModal({
                      open: true,
                      message: `Another active GradMap session is still open. Click Continue to log you out of any other active session to avoid any potential data loss.`,
                      activeSessions: res2.payload.activeSessions || [],
                    });
                    // setSubmitting(false);
                    releaseCreateButton();
                    return;
                  }
                  else
                  if (res2.payload.statusCode === 400) {
                    if (res2.payload.message === 'User not found') {
                      toast.error('User not found');
                      history.push(routers.register.path);
                      releaseCreateButton();
                      return;
                    }

                    // else show error message
                    if (res2.payload.errorCode === 100) {
                      toast.error('Invalid User or Password');
                    }
                    else
                      toast.error(res2.payload.message);

                    releaseCreateButton();
                    return;
                  } 
                  else
                  if (res2.payload.statusCode === 500) {
                    toast.error(res2.payload.message);
                    releaseCreateButton();
                    return;
                  }         
                  //#endregion

                  // Process successful login
                  //await processLoginSuccess(res);

                  console.log('login: res32:', res2);
                  switch(res2.payload.user_role) {
                    case USER_ROLE.student:
                      //#region Active Free Plan
                      const studentId = Number(res2.payload?.student_id) || Number(getUserId()?? 0);
                      const res3:any = await PaymentServices.activeFreePlan(
                        studentId,
                        formik.values.email,
                        formik.values.first_name,
                        formik.values.last_name,
                      )
                      console.log('activeFreePlan() ~ res3:', res3);
                      //#endregion

                      if (res3 && res3.statusCode === 200) {
                        toast.success(res3.message);
                        handleNextStep('3a');
                      } else {
                        releaseCreateButton();
                      }
                      break;
                    case USER_ROLE.parent:
                      handleNextStep('3b');
                      break;
                    case USER_ROLE.counselor:
                      handleNextStep('3c');
                      break;
                  }
                } else {
                  releaseCreateButton();
                }

              }

            //#endregion
            }
            else{
              if (res.payload?.response?.data?.statusCode === 400) {
                let message: string = res.payload?.response?.data?.message ?? '';
                if (message.includes('Duplicated user email')) {
                  const tok = getPersistedInviteToken();
                  if (tok) {
                    toast.error('This email already has an account. Sign in to accept the invitation.');
                    history.push(`${routers.login.path}?${INVITE_TOKEN_QUERY}=${encodeURIComponent(tok)}`);
                  } else {
                    handleNextStep('2');
                    formik.setErrors({
                      email: 'The email is already used. Please choose another one.',
                    });
                    formik.setFieldTouched('email', true, false);
                  }
                }
                releaseCreateButton();
                return;
              }

              if (res.payload?.statusCode === 400) {
                let message: string = res.payload?.message ?? ''; 
                if (message.includes('Duplicated user email')) {
                  const tok = getPersistedInviteToken();
                  if (tok) {
                    toast.error('This email already has an account. Sign in to accept the invitation.');
                    history.push(`${routers.login.path}?${INVITE_TOKEN_QUERY}=${encodeURIComponent(tok)}`);
                  } else {
                    handleNextStep('2');
                    formik.setErrors({
                      email: 'The email is already used. Please choose another one.',
                    });
                    formik.setFieldTouched('email', true, false);
                  }
                } 
                else if (message.includes('Duplicated parent email')) {
                  handleNextStep('2');
                  formik.setFieldError('parent_email', `The email is already used. Please choose another one.`);
                  formik.setFieldTouched('parent_email', true, false);
                } else if (message) {
                  toast.error(message);
                }
                releaseCreateButton();
                return;
              }

              const fallbackMessage =
                typeof res.payload === 'string'
                  ? res.payload
                  : res.payload?.message;
              if (fallbackMessage) {
                toast.error(fallbackMessage);
              } else {
                toast.error('Registration failed. Please try again.');
              }
              releaseCreateButton();
              return;
            }
        } 
        else 
        if (step==='3c') {
          studentId = getUserId();
          token = getAccessToken();
          console.log('current token: ', token);
          console.log('current userRole: ', userRole);
          if (token && studentId && userRole === USER_ROLE.counselor) {
            const body:any = {
              ...values,
              additional_info: JSON.stringify(values.additional_info),
            };
            // remove unused properties
            const {high_school_code, high_school_object, ...newValues} = body;
           
            await basicInformationServices.update({
               student_id: studentId,
               school_or_organization_work_with: values.school_or_organization_work_with,
               additional_info: newValues.additional_info,
            });

            toast.success('Save successfully');
            handleNextStep('phone');
          }
          else {
            handleLogout();
          }
        }
      } catch (error) {
        console.log('dispatch Error:', error);
        releaseCreateButton();
      }
    },
    
  });

  const inviteAppliedRef = React.useRef(false);
  const invitePrefillAppliedRef = React.useRef(false);

  /** Auto-fill email + name from GET /partner/invite/validate (once per successful validation) */
  React.useEffect(() => {
    const inv = inviteValidation.data;
    if (!inv?.valid || invitePrefillAppliedRef.current) return;
    const em = (inv.invitee_email || '').trim();
    const fn = (inv.invitee_first_name || '').trim();
    const ln = (inv.invitee_last_name || '').trim();
    if (em) formik.setFieldValue('email', em, false);
    if (fn) formik.setFieldValue('first_name', fn, false);
    if (ln) formik.setFieldValue('last_name', ln, false);
    if (em || fn || ln) invitePrefillAppliedRef.current = true;
  }, [inviteValidation.data]);

  React.useEffect(() => {
    userRole = sessionStorage.getItem('userRole');
    if (userRole) {
      formik.setFieldValue('user_role', userRole, false);
    }
  }, []);

  React.useEffect(() => {
    if (step !== '2') {
      setRegisterCreateLocked(false);
    }
  }, [step]);

  React.useEffect(() => {
    if (stepURL) {
      setStep(stepURL);
    }
  }, [stepURL]);

  /** Valid invite: prefill role/email and skip role selection */
  React.useEffect(() => {
    const inv = inviteValidation.data;
    if (!inv?.valid || !inv.invite_kind || inviteAppliedRef.current) return;
    if (stepURL && stepURL !== '1') return;

    if (inv.invite_kind === 'studentInviteParent') {
      formik.setFieldValue('user_role', USER_ROLE.parent, false);
      sessionStorage.setItem('userRole', USER_ROLE.parent);
    } else if (inv.invite_kind === 'parentInviteStudent') {
      formik.setFieldValue('user_role', USER_ROLE.student, false);
      sessionStorage.setItem('userRole', USER_ROLE.student);
    }
    inviteAppliedRef.current = true;
    setStep('2');
    let path = history.location.pathname;
    if (!path || path === '/') {
      path = '/public/register';
    }
    const raw = (history.location.search || '').replace(/^\?/, '');
    const params = new URLSearchParams(raw);
    params.set('step', '2');
    const t = getPersistedInviteToken();
    if (t) params.set(INVITE_TOKEN_QUERY, t);
    history.replace({ pathname: path, search: `?${params.toString()}` });
  }, [inviteValidation.data, stepURL]);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getUserPassValidationSchema = (provider: any) => {
    return Yup.object().shape({
      email: Yup.string().email('Invalid email').required('This field is required'),
      first_name: Yup.string().required('This field is required'),
      last_name: Yup.string().required('This field is required'),
      password: provider 
        ? Yup.string().notRequired() 
        : Yup.string()
          .min(6, 'Password must be at least 6 characters')
          .required('This field is required'),
      password_confirm: provider
        ? Yup.string().notRequired()
        : Yup.string()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required('This field is required'),
    });
  };

  const validateStep = async (currentStep: string) => {
    console.log('current step: ', step);

    let schema;
    switch (currentStep) {
      case '2':
        schema = getUserPassValidationSchema(provider);
        break;
      case '3c':
      default:
        return true;
    }

    try {
      if (schema) {
        await schema.validate(formik.values, { abortEarly: false });
        return true;
      }
    } 
    catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors: any = {};
        err.inner.forEach((error) => {
          if (error.path) {
            errors[error.path] = error.message;
          }
        });
        formik.setErrors(errors);
      }
      return false;
    }
  };

  const handleNextStep = async (nextStep: string, force:boolean=false) => {   
    let isValid = await validateStep(step);
    if (force) isValid = true;
    if (isValid) {
      setStep(nextStep);
      changeHashStep(nextStep);
    }
  };

  const changeHashStep = (nextStep: string) => {
    let path = history.location.pathname;
    if (!path || path === '/') {
      path = '/public/register';
    }
    const raw = (history.location.search || '').replace(/^\?/, '');
    const params = new URLSearchParams(raw);
    params.set('step', nextStep);
    const t = getPersistedInviteToken();
    if (t) params.set(INVITE_TOKEN_QUERY, t);
    history.replace({ pathname: path, search: `?${params.toString()}` });
  };

  const inviteTokenActive =
    getInviteTokenFromSearch(locationSearch) || getPersistedInviteToken();

  if (inviteTokenActive && inviteValidation.loading) {
    return (
      <CreateAccountLayout>
        <div className="p-5 text-center text-neutral-700">Verifying your invitation…</div>
      </CreateAccountLayout>
    );
  }

  if (inviteTokenActive && inviteValidation.error) {
    return (
      <CreateAccountLayout>
        <div className="p-5 m-3 max-w-lg mx-auto">
          <h2 className="h4 mb-3">Invitation unavailable</h2>
          <p className="text-neutral-700 mb-3">{inviteValidation.error}</p>
          <p className="text-muted small mb-4">
            Ask the sender to send a new invitation from GradMap if you still need access.
          </p>
          <Button
            variant="primary"
            onClick={() => {
              clearPartnerInviteContext();
              history.replace({ pathname: routers.login.path, search: '' });
            }}
          >
            Back to sign in
          </Button>
        </div>
      </CreateAccountLayout>
    );
  }

  return (
    <>
    {(step === '1') && (
      <CreateAccountLayout>
        <FormChooseRole
          onNextStep={(e) => {
            handleNextStep(e);
          }}
          formik={formik}
        />
      </CreateAccountLayout>
    )}
  
    {(step === '2') && (
      <CreateAccountLayout>
        <FormRegister
            loginCredentials={loginCredentials}
            setLoginCredentials={setLoginCredentials}
            setProvider={setProvider}
            onNextStep={(e) => {
              handleNextStep(e);
            }}
            formik={formik}
            provider={provider}
            registerCreateLocked={registerCreateLocked}
            setRegisterCreateLocked={setRegisterCreateLocked}
            inviteEmailLocked={Boolean(
              inviteValidation.data?.valid && inviteValidation.data?.invitee_email
            )}
        />
      </CreateAccountLayout>
    )}

    {(step === '3a') && (
      <CreateAccountLayout>
        <FormStudentInfo
          formik={formik}
          onNextStep={(e) => {
            handleNextStep(e);
          }}
        />
      </CreateAccountLayout>
    )}
    {(step === '3b') && (
      <CreateAccountLayout>
        <FormInviteStudent 
          formik={formik}
          onNextStep={(e) => {
            handleNextStep(e);
          }}
        />
      </CreateAccountLayout>
    )}
     {(step === '3c') && (
      <CreateAccountLayout>
        <FormCounselorSetup 
          formik={formik}
          onNextStep={(e) => {
            handleNextStep(e);
          }}
        />
      </CreateAccountLayout>
    )}

    {(step === 'phone') && (
      <CreateAccountLayout>
        <FormAuthPhoneNumber
          setStep={(value) => handleNextStep(value)}
          currentStep={step}
          formik={formik}
        />
      </CreateAccountLayout>
    )}
    
    {(step === '4') && (
      <div>
      <>
      <div className="register-form p-0 m-0 row">
        <div className="d-none d-md-none p-0 col-12">
          <img alt="GradMap logo" src="/assets/images/Topbar.png" width="100%" />
        </div>
        <div className="d-flex h-100 p-0 pb-5 mb-5 col-md-12">
          <FormGradMapReady
            formik={formik}
            onNextStep={(e) => {
              handleNextStep(e);
            }}
          />
        </div>
      </div>


      </>
      </div>
    )} 
    </>
  )
};


export default RegisterPage;
